import React from "react";
import ProductCard from "./ProductCard";
import "./ProductsSection.css";

function ProductsSection({
  firstProductImg,
  secondProductImg,
  firstProductDetails,
  secondProductDetails,
  firstProductLink,
  secondProductLink,
  mangoSourBeltImg,
  mangoSourBeltDetails,
  mangoSourBeltLink,
  rainbowSourBeltImg,
  rainbowSourBeltDetails,
  rainbowSourBeltLink,
  buttonLabel,
}) {
  return (
    <>
      <div className="home__products-section-row">
        <div className="home__products-section-title">Our Products</div>
      </div>
      <div className="home__products-section-row">
        <div className="home__products-col">
          <ProductCard 
            productImg={firstProductImg}
            productTitle="Fruit Snacks"
            productDetails={firstProductDetails}
            productLink={firstProductLink}
            buttonLabel={buttonLabel}
          />
        </div>
        <div className="home__products-col">
          <ProductCard 
            productImg={secondProductImg}
            productTitle="Sour Fruit Snacks"
            productDetails={secondProductDetails}
            productLink={secondProductLink}
            buttonLabel={buttonLabel}
          />
        </div>
        
      </div>

      <div className="home__products-section-row">
        <div className="home__products-col">
          <ProductCard 
            productImg={rainbowSourBeltImg}
            productTitle="Rainbow Sour Belts"
            productDetails={rainbowSourBeltDetails}
            productLink={rainbowSourBeltLink}
            buttonLabel={buttonLabel}
          />
        </div>
        <div className="home__products-col">
          <ProductCard 
            productImg={mangoSourBeltImg}
            productTitle="Mango Sour Belts"
            productDetails={mangoSourBeltDetails}
            productLink={mangoSourBeltLink}
            buttonLabel={buttonLabel}
          />
        </div>
      </div>
    </>
  );
}

export default ProductsSection;
